module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "dedicationPage",
    attrs: {
      "id": "ded01"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagevii"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "dedicationText"
  }, [_vm._v("This book is dedicated to my mother, Carol, who passed away during the final edits. She is sorely missed.")]), _vm._v(" "), _c('p', {
    staticClass: "dedicationText"
  }, [_vm._v("To my daughters, and lights of my life, Joelle Rebecca and Emma Grace.")]), _vm._v(" "), _c('p', {
    staticClass: "dedicationText"
  }, [_vm._v("And, to the 100,000s of newbies who I’ve had the pleasure of working with at "), _c('a', {
    attrs: {
      "href": "http://trendfund.com",
      "target": "_blank"
    }
  }, [_vm._v("trendfund.com")]), _vm._v(" and Trend Trading to Win, all of us searching for ways to a better life in this crazy world. Peace and prosperity to all.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "pageviii"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ac77255","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ruleyourfreakinretirement_ded01.vue
// module id = 69
// module chunks = 0